import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.com/docs/use-static-query/
 */

const Image = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "flowerFinal.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100 ) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  if (!data?.placeholderImage?.childImageSharp?.fluid) {
    return <div>Picture not found</div>
  }

  // ohje!! return <Img fluid={data.placeholderImage.childImageSharp.fluid} style={{marginTop:'1rem',marginRight: '20%', marginLeft: '20%', maxHeight: 'calc(30vh - 4rem)' }}
  // imgStyle={{ objectFit: 'contain' }} />


  return <Img fluid={data.placeholderImage.childImageSharp.fluid} style={{marginTop:'1rem',marginRight: '20%', marginLeft: '20%', maxHeight: 'calc(30vh - 4rem)', position: 'unset' }}
  imgStyle={{ objectFit: 'contain', position: 'absolute', zIndex: '-1' }} />
}
  // return <Img fluid={data.placeholderImage.childImageSharp.fluid} style={{marginTop:'1rem' }}
  // imgStyle={{ objectFit: 'contain' }} />
//}

export default Image
